var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 14.32C35.8799 14.3 35.7399 14.3 35.6199 14.32C32.8599 14.22 30.6599 11.96 30.6599 9.16C30.6599 6.3 32.9599 4 35.8199 4C38.6799 4 40.9799 6.32 40.9799 9.16C40.9599 11.96 38.7599 14.22 35.9999 14.32Z",
    stroke: "#D12E29",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9399 28.8803C36.6799 29.3403 39.6999 28.8603 41.8199 27.4403C44.6399 25.5603 44.6399 22.4803 41.8199 20.6003C39.6799 19.1803 36.6199 18.7003 33.8799 19.1803",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.94 14.32C12.06 14.3 12.2 14.3 12.32 14.32C15.08 14.22 17.28 11.96 17.28 9.16C17.28 6.3 14.98 4 12.12 4C9.25996 4 6.95996 6.32 6.95996 9.16C6.97996 11.96 9.17996 14.22 11.94 14.32Z",
    stroke: "#D12E29",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 28.8803C11.2599 29.3403 8.23988 28.8603 6.11988 27.4403C3.29988 25.5603 3.29988 22.4803 6.11988 20.6003C8.25988 19.1803 11.3199 18.7003 14.0599 19.1803",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 29.2604C23.8799 29.2404 23.7399 29.2404 23.6199 29.2604C20.8599 29.1604 18.6599 26.9004 18.6599 24.1004C18.6599 21.2404 20.9599 18.9404 23.8199 18.9404C26.6799 18.9404 28.9799 21.2604 28.9799 24.1004C28.9599 26.9004 26.7599 29.1804 23.9999 29.2604Z",
    stroke: "#D12E29",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1799 35.5607C15.3599 37.4407 15.3599 40.5207 18.1799 42.4007C21.3799 44.5407 26.6199 44.5407 29.8199 42.4007C32.6399 40.5207 32.6399 37.4407 29.8199 35.5607C26.6399 33.4407 21.3799 33.4407 18.1799 35.5607Z",
    stroke: "#292D32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.91cd9fb803cf9f69371ed1e7a90c6144.svg";
export { ForwardRef as ReactComponent };